import validator from 'validator'
import { validatePhone } from '@containers/common/validators'
import { ROLES } from '@lib/enums/dashboard'

export const validateRegistrationFormData = (data) => {
  const errors = {}

  if (!validator.isEmail(data.email)) {
    errors['email'] = ['Please enter a valid email']
  }

  if (validator.isEmpty(data.name)) {
    errors['name'] = ['Please enter your name']
  }

  const phoneErrors = validatePhone(data.phone)
  if (Object.keys(errors).length) {
    errors['phone'] = phoneErrors['phone']
  }

  if (!data.termsAndConditions) {
    errors['termsAndConditions'] = [
      'Please accept terms and conditions to proceed',
    ]
  }

  if (data.role === ROLES.TEACHER) {
    if (data.teacherGender.value === 'select') {
      errors['teacherGender'] = ['Please select a gender']
    }

    if (data.teacherExperience.value === 'select') {
      errors['teacherExperience'] = ['Please select your experience']
    }

    if (data.teacherEducationalQualification.value === 'select') {
      errors['teacherEducationalQualification'] = [
        'Please select your qualification',
      ]
    }
  }

  if (data.role === ROLES.STUDENT) {
    if (!data.childConsent) {
      errors['childConsent'] = ['Please provide consent']
    }
    if (data.childGrade.value === 'select') {
      errors['childGrade'] = ['Please select your grade']
    }

    if (data.childGender.value === 'select') {
      errors['childGender'] = ['Please select your gender']
    }
    if (data.hasLaptop === null) {
      errors['hasLaptop'] = ['Please add a response here']
    }
  }

  return errors
}
